/**
 * MCP client setup (docs/CLAUDE_CODE_INTEGRATION.md): where this deployment's
 * /mcp endpoint lives, and the Claude Code config that reaches it with a key.
 */

/** API origin: VITE_API_URL in production; the backend's :8080 behind the Vite dev server. */
export function apiBase(): string {
    const envBase = import.meta.env.VITE_API_URL as string | undefined;
    if (envBase) return envBase.replace(/\/$/, '');
    const { protocol, hostname, port } = window.location;
    if (port === '5173') return `${protocol}//${hostname}:8080`;
    return window.location.origin;
}

/**
 * `headersHelper`, not `headers`: Claude Code runs OAuth discovery on servers
 * configured with `headers` and marks bearer-only servers "not authenticated".
 */
export function mcpJsonSnippet(token: string, base = apiBase()): string {
    return JSON.stringify(
        {
            mcpServers: {
                kaziatlas: {
                    type: 'http',
                    url: `${base}/mcp`,
                    headersHelper: `echo '{"Authorization": "Bearer ${token}"}'`,
                },
            },
        },
        null,
        2,
    );
}
